/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
// components/Counter.tsx
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import Steper from "../../components/steper/Steper";
import Product from "../../components/product/Product";
import { Backdrop, Skeleton } from "@mui/material";
import { RootState } from "../../store/reducers";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { actionCreators } from "../../store";
import { handleAllBookingCategoryExtra } from "../../helper/productFunction";
import { apiService } from "../../services";
import { v4 as uuidv4 } from "uuid";
import CategoryBanner from "../../components/CategoryBanner/CategoryBanners";
import { get_lang } from "../../helper/getLang";
import ExtrasFieldsPopup from "../../components/ExtrasFieldsPopup/ExtrasFieldsPopup";
import { sortedByNumber } from "../../utils";
import { useTranslation, withTranslation } from "react-i18next";
import NewNextBtn from "../../components/BtnNext/NewNextBtn";
const Step2 = () => {
  const { t } = useTranslation();
  const appState = useSelector((state: RootState) => state.appReducer);
  const { bookingForm } = appState;
  const dispatch = useDispatch();
  const { setExtrasFieldsPopup, setCart, alertMessageState } =
    bindActionCreators(actionCreators, dispatch);
  const apiState = useSelector((state: RootState) => state.apiReducer);
  const { storeId } = apiState;
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams: any = new URLSearchParams(search);
  const [bId] = useState(searchParams.get("bId"));
  const { slug } = useParams();
  const [apiLoading, setApiLoading] = useState(false);
  const [tempCart, setTempCart,]: any = useState(appState?.cart);
  const [bookingCategoriesExtras, setBookingCategoriesExtras] = useState([]);
  const [extrasLimit, setExtrasLimit] = useState<any[]>([]);
  const [extras, setExtras]: any = useState([]);
  const [cartObj, setcartObj]: any = useState({});
  const [errorStatus, setErrorStatus] = useState(false);
  const [nextButtonStatus, setNextButtonStatus] = useState(true);
  const [nextButtonStatusIninital, setNextButtonStatusIninital] = useState(true)
  
  useEffect(() => {
    if (appState.bookingForm == undefined || appState.bookingForm == null) {
      navigate(`/${slug}/step-1?bId=${bId}`);
    }
    setExtrasFieldsPopup(false);
  }, []);

  const getBookingCategoriesExtras = async (categoryId: number | string) => {
    try {
      setApiLoading(true);
      const res = await apiService.getBookingCategoriesExtras(categoryId);
      if (res?.data.success == true) {
        let extrassItem = res?.data?.data;
        if (extrassItem?.length > 0) {
          let customRes = handleAllBookingCategoryExtra(
            bId,
            extrassItem,
            appState?.cart,
            setNextButtonStatusIninital,
            nextButtonStatusIninital,
            setNextButtonStatus
          );
          setBookingCategoriesExtras(extrassItem);
          let sortedArry: any = sortedByNumber(customRes.arryExtraLimit);
          setExtrasLimit(sortedArry);
          setExtras(sortedByNumber(customRes.extrasInfo));
          setTempCart(customRes?.localCart);
          setCart(customRes?.localCart);
        }
        //      else{
        // navigate(`/${slug}/step-3?bId=${bId}`);

        //      }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setApiLoading(false);
    }
  };
  useEffect(() => {
    // document.documentElement.style.setProperty("--th-primary", "#EB5B5E");
  }, [storeId]);

  useEffect(() => {
    getBookingCategoriesExtras(searchParams.get("bId"));
  }, []);

  const handleCloseBackDrop = () => {
    setExtrasFieldsPopup(false);
  };
  const handleGetCart = (type: any, item: any) => {
    let cartFlag = false;
    let getExtrasLimit: any = extrasLimit?.find(
      (ele: any) => ele.id == item?.category_extra_id
    );
    let ex: any = [...extras];
    let cart_id = uuidv4();
    let localcart: any = appState?.cart ? [] : [...appState?.cart];
    let getFromCart =
      appState?.cart?.length > 0
        ? appState?.cart.find(
            (cartItem: any) => cartItem.booking_extra_id == item.extra_id
          )
        : null;

    if (getFromCart) {
      item.quantity = getFromCart?.quantity;
      cartFlag = true;
    } else if(getExtrasLimit?.extras_qty < getExtrasLimit?.max && getExtrasLimit?.max != null)  {
      item.quantity = 1;
      cartFlag = true;
    }
if(cartFlag){
  
  ex.forEach((ele: any) => {
    if (item.extra_id == ele.extra_id) {
      if (getFromCart) {
        ele.quantity = getFromCart?.quantity;
      }
    }
  });
  setExtras(ex);

  var currentCart = {
    id: cart_id,
    category_extra_id: item?.category_extra_id,
    booking_extra_id: item?.extra_id,
    extra_id: item?.extra_id,
    quantity: item.quantity,
    values: [],
    price: item?.price,
    image: item?.image,
    maxQuantity: item?.maxQuantity,
    prod_title: item.extra,
    check_status: false,
    multiple: item.multiple,
    bId: Number(bId) ?? null,
  };
  // let hasFieldCart
  localcart = [...localcart, currentCart, ...tempCart];
  setTempCart(localcart);
  setcartObj(currentCart);
}
    // setCart(localcart)
  };

  const handleRemove = (item: any) => {
    const newCart: any = [...appState?.cart];
    const itemIndx: any = newCart.findIndex(
      (ele: any) => ele.booking_extra_id == item.extra_id
    );
    let ex: any = [...extras];
    ex.forEach((ele: any) => {
      if (item.extra_id == ele.extra_id) {
        if (ele.quantity > 0) {
          ele.quantity = 0;
        }
      }
    });

    setExtras(ex);
    newCart.splice(itemIndx, 1);
    setCart(newCart);
  };

  const handleIncrement = (item: any) => {
    let getExtrasLimit: any = extrasLimit?.find(
      (ele: any) => ele.id == item?.category_extra_id
    );

    let tmcart: any = [...tempCart];
    let findTempInd = tmcart.findIndex(
      (ele: any) => ele.booking_extra_id == item.extra_id
    );

    if (findTempInd > -1) {
      if (
        tmcart[findTempInd].quantity < tmcart[findTempInd]?.maxQuantity &&
        getExtrasLimit?.extras_qty < getExtrasLimit?.max
      ) {
        tmcart[findTempInd].quantity = tmcart[findTempInd].quantity + 1;
      }
    }

    let ex: any = [...extras];
    ex.forEach((ele: any) => {
      if (item.extra_id == ele.extra_id) {
        if (
          ele.quantity < ele.maxQuantity &&
          getExtrasLimit?.extras_qty < ele.max
        ) {
          ele.quantity = ele.quantity + 1;
        }
      }
    });

    setExtras(ex);
    setTempCart(tmcart);
  };

  const handleDecrement = (item: any) => {
    let tmcart: any = [...tempCart];

    let findTempInd = tmcart.findIndex(
      (ele: any) => ele.booking_extra_id == item.extra_id
    );
    if (findTempInd > -1) {
      if (tmcart[findTempInd].quantity > 0) {
        tmcart[findTempInd].quantity = tmcart[findTempInd].quantity - 1;
        let ex: any = [...extras];
        ex.forEach((ele: any) => {
          if (item.extra_id == ele.extra_id) {
            if (ele.quantity > 0) {
              ele.quantity = ele.quantity - 1;
            }
          }
        });

        setExtras(ex);
      }
      if (tmcart[findTempInd].quantity < 1) {
        tmcart.splice(findTempInd, 1);
        handleRemove(item);
      }
    }

    setTempCart(tmcart);
  };

  const handleExtrasLimit = (): void => {
    let newArry: any = [...extrasLimit];
    for (let i = 0; i < newArry.length; i++) {
      let arr: number[] = [];
      let sum: number = 0;
      for (let k = 0; k < extras.length; k++) {
        if (extras[k]?.category_extra_id === newArry[i].id) {
          arr.push(extras[k]?.quantity);
        }
      }
      for (let j = 0; j < arr.length; j++) {
        sum += arr[j];
        newArry[i].extras_qty = sum;
      }
    }
    setExtrasLimit(newArry);
  };

  useEffect(() => {
    if (extras.length > 0) {
      handleExtrasLimit();
    }
  }, [extras]);


  const handleNext = () => {
    let error = "";
  
    // Find the first item that doesn't meet the condition
    const invalidExtra = extrasLimit.find((ele: any) => ele.min != null && ele.extras_qty < ele.min);
  
    if (invalidExtra) {
      error = `${t("custom-msg.Addons-quantity-required")} (${invalidExtra.min})`;
  
      // Show error message
      setErrorStatus(true);
      setTimeout(() => setErrorStatus(false), 2000);
  
      alertMessageState({
        type: "error",
        show: true,
        message: error,
      });
  
      // Scroll to the invalid element
      const element = document.getElementById(invalidExtra.id);
      if (element) {
        const yOffset = -10;
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
  
      return; // Exit early since an invalid item was found
    }
  
    // If everything is valid, proceed
    setCart(tempCart);
    navigate(`/${slug}/step-3?bId=${bId}`);
  };
  

  const handleGoBack = () => {
    navigate(`/${slug}/step-1?bId=${bId}`);
  };

  useEffect(() => {
    if(tempCart.length > 0 && !nextButtonStatus){
      setNextButtonStatus(true)
    }
    else if(tempCart.length == 0 && nextButtonStatus){
      setNextButtonStatus(nextButtonStatusIninital)
    }
  }, [tempCart])
  

  return (
    <div id="Steper2" className={` ${
      appState.langValue === "ar" ? `direction-rtl` : "direction-ltr"
    }`}>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme: any): any => theme.zIndex.drawer + 1,
        }}
        open={appState?.extrasFieldsPopup}
        onClick={handleCloseBackDrop}
      ></Backdrop>
      <CategoryBanner handleGoBack={handleGoBack} />
      <div className="px-3"> 
     
        <Steper
          label={`${t("Choose Options")}`}
          labelDecs={``}
          steps={true}
          stepNo={2}
          howMaysteps={3}
        />
        {apiLoading ? (
          <div className="py-2">
            <div className="col-md-12  ">
              <Skeleton height={100} />
            </div>
            <div className="col-md-12  ">
              <Skeleton height={100} />
            </div>
          </div>
        ) : (
          <React.Fragment>
            <div className="mt-4  mb-5 pb-5 categoryParent pt-2">
              {extrasLimit.length > 0 ? (
                extrasLimit.map((main: any, i: any) => {
                  return (
                    <React.Fragment>
                      {main.extras_length > 0 ? (
                        main.extras_length > 0 &&
                        main.min == 1 &&
                        main.max == 1 ? (
                          <span id={`${main.id}`} key={i}>
                            <section
                              key={i}
                              id="single-pro"
                              className="row m-0"
                            >
                              <div
                                // ref={myRef}
                                id={`single-pro${main.id}`}
                                className="col-12 p-0"
                              >
                                <div className="row m-0">
                                  <div className="col-12 p-0">
                                    <h5
                                      className="d-flex m-0 familysora600 mainHeading"
                                      style={
                                        main.min != null &&
                                        main.min > main.extras_qty &&
                                        errorStatus
                                          ? { color: "red" }
                                          : { color: "black" }
                                      }
                                    >
                                      {get_lang(
                                        main.title,
                                        appState?.langValue
                                      )}
                                      :
                                      {main.min != null && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </h5>
                                    {main.min != null && (
                                      <p
                                        className={`d-flex text-muted choosecontent p-0 mx-0 my-3 ${
                                          appState?.langValue == "ar"
                                            ? "text-right direction-rtl"
                                            : "text-left direction-ltr"
                                        }`}
                                      >
                                        {main.min == 1 &&
                                          main.max == 1 &&
                                        t("Selection is required")}
                                        {main.min == 1 &&
                                          main.max == null &&
                                          t("At least select") + main.min}
                                        :
                                      </p>
                                    )}
                                    {extras.length > 0 &&
                                      extras.map((item: any, ind: any) => {
                                        return (
                                          item.category_extra_id == main.id && (
                                            <Product
                                              item={item}
                                              key={ind}
                                              handleRemove={handleRemove}
                                              handleGetCart={handleGetCart}
                                              handleIncrement={handleIncrement}
                                              handleDecrement={handleDecrement}
                                            />
                                          )
                                        );
                                      })}
                                  </div>
                                </div>
                              </div>
                            </section>
                          </span>
                        ) : (
                          <span id={`${main.id}`} key={i}>
                            <section
                              key={i}
                              id="single-pro"
                              className="row m-0"
                            >
                              <div
                                id={`single-pro${main.id}`}
                                className="col-12 p-0"
                              >
                                <div
                                  id={`single-pro${main.id}`}
                                  className="col-12 p-0"
                                >
                                  <div className="row m-0">
                                    <div className="col-12 p-0">
                                      <h5
                                        className={`m-0 text-capitalize familysora600 mainHeading ${
                                          appState?.langValue == "ar"
                                            ? "text-right direction-rtl"
                                            : "text-left direction-ltr"
                                        }`}
                                        style={
                                          main.min != null &&
                                          main.min > main.extras_qty &&
                                          errorStatus
                                            ? { color: "red" }
                                            : { color: "black" }
                                        }
                                      >
                                        {get_lang(
                                          main.title,
                                          appState?.langValue
                                        )}{" "}
                                        :
                                        {main.min != null && (
                                          <span className="text-danger">*</span>
                                        )}
                                      </h5>
                                      {main.min != null && (
                                        <p
                                          className={`d-flex text-muted choosecontent p-0 mx-0 my-3 ${
                                            appState?.langValue == "ar"
                                              ? "text-right direction-rtl"
                                              : "text-left direction-ltr"
                                          }`}
                                        >
                                          {t("Select at least")} {main.min}
                                          {` ${
                                            main.max != null
                                              ? `${t("up to")} ${main.max}`
                                              : ``
                                          } `}
                                        </p>
                                      )}
                                      {extras.length > 0 &&
                                        extras.map((item: any, ind: any) => {
                                          return (
                                            item.category_extra_id ==
                                              main.id && (
                                              <Product
                                                item={item}
                                                key={ind}
                                                handleRemove={handleRemove}
                                                handleGetCart={handleGetCart}
                                                handleIncrement={
                                                  handleIncrement
                                                }
                                                handleDecrement={
                                                  handleDecrement
                                                }
                                              />
                                            )
                                          );
                                        })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </span>
                        )
                      ) : (
                        ""
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <div className="mt-3 categoryParent pt-2 flex-center-center">
                  <h3>{t("No Extras")}</h3>
                </div>
              )}
            </div>
          </React.Fragment>
        )}

        {
          <NewNextBtn
            handleCheckout={handleNext}
            label="Next"
            // disBtn={!(tempCart.length > 0)}
            // disBtn={!nextButtonStatus}
          />
        }
        {appState?.extrasFieldsPopup && (
          <ExtrasFieldsPopup
            handleIncrement={handleIncrement}
            handleDecrement={handleDecrement}
            currentCart={cartObj}
            tempCart={tempCart}
            setTempCart={setTempCart}
          />
        )}
      </div>
    </div>
  );
};

export default withTranslation()(Step2);
